// extracted by mini-css-extract-plugin
module.exports = {"info":"about_info_6d0u3","socialMedia":"about_socialMedia_1Zrve","iconContainer":"about_iconContainer_236gX","icon":"about_icon_2LN9O"};